import { Outlet } from "react-router-dom";
import { OnboardingProvider } from "@/providers/OnboardingProvider";
import { TenantBlockedProvider } from "@/contexts/TenantBlockedContext";
import { TenantBlockedBannerHost } from "@/components/PBanner/TenantBlockedBannerHost";
import { SubscriptionExpiryBannerHost } from "@/components/PBanner/SubscriptionExpiryBannerHost";
import { SAppBar } from "@/components/AppBar/SAppBar";
import { GlobalSearch } from "@/components/PSearch/GlobalSearch";
import { POnboarding } from "@/components/POnboarding/POnboarding";
import { CompanyScopedAiAssistant } from "@/providers/AiAssistantProvider";
import { tenantBlockedStore } from "@/lib/auth/tenantBlockedStore";

export function DashboardShell() {
  const initialBlocked = tenantBlockedStore.isBlocked();

  return (
    <TenantBlockedProvider initialBlocked={initialBlocked}>
      <OnboardingProvider initialProgress={null}>
        {/* Company-scoped AI assistant (drawer + FAB) — event pages mount the
            event-scoped twin inside EventLayoutShell instead. */}
        <CompanyScopedAiAssistant>
          <div
            data-testid="page-root"
            className="surface-secondary flex flex-col w-full min-h-screen font-primary transition-[padding] duration-[250ms] ease-[cubic-bezier(0.4,0,0.2,1)] motion-reduce:transition-none sm:pr-[var(--ai-rail-push)]"
          >
            <SAppBar />
            {/* Advisory strips sit BELOW the bar and IN FLOW.
                - Above the bar is wrong: PUserSettings/PNotifications are
                  `fixed top-12` and would detach from their triggers, and the
                  SAppBar error branch renders an `AppBarStripped` that is
                  itself `fixed top-0`.
                - Out of flow is wrong: a `fixed z-40` strip loses the paint
                  order tie to the sticky bar (also z-40, later in the DOM) and
                  spans under the z-10000 Velo rail, hiding its own ✕.
                Inside page-root they inherit `sm:pr-[var(--ai-rail-push)]`, so
                they shrink with the rail instead of sliding beneath it. */}
            <TenantBlockedBannerHost />
            <SubscriptionExpiryBannerHost />
            <Outlet />
          </div>
          <GlobalSearch />
          <POnboarding />
        </CompanyScopedAiAssistant>
      </OnboardingProvider>
    </TenantBlockedProvider>
  );
}
